import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useUrlParam = (name: string, shouldReplace = true) => {
  const location = useLocation();
  const navigate = useNavigate();

  const urlParam = new URLSearchParams(location.search).get(name);

  const setParam = useCallback(
    (value: string) => {
      const params = new URLSearchParams(location.search);
      params.set(name, value);
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: shouldReplace }
      );
    },
    [location.pathname, location.search, name, navigate, shouldReplace]
  );

  const removeParam = useCallback(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has(name)) return;
    params.delete(name);
    navigate(
      { pathname: location.pathname, search: params.toString() },
      { replace: shouldReplace }
    );
  }, [location.pathname, location.search, name, navigate, shouldReplace]);

  return { urlParam, setParam, removeParam };
};
